import { createI18n } from 'vue-i18n'
import Cookies from 'js-cookie'
import en from './en.json'
import ru from './ru.json'

const locale = Cookies.get('locale') || 'ru'

export const i18n = createI18n({
  legacy: false,
  locale,
  fallbackLocale: 'ru',
  messages: {
    en,
    ru,
  },
})

